import { render } from "./NoticeMaster.vue?vue&type=template&id=d7471d66&scoped=true"
import script from "./NoticeMaster.vue?vue&type=script&lang=js"
export * from "./NoticeMaster.vue?vue&type=script&lang=js"

import "./NoticeMaster.vue?vue&type=style&index=0&id=d7471d66&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7471d66"]])

export default __exports__